export default __webpack_public_path__ + "static/media/Background_00218.dbe525c8.png";